import React from "react";
import "../assets/styles/Register.css";

const Register = () => {
  return <div className="register">Wir arbeiten darüber</div>;
};

export default Register;
